import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import Header from "../../../Component/Header";
import Menu from "../../../Component/Menu";
import Footer from "../../../Component/Footer";
import { Link, useNavigate } from "react-router-dom";
import TourServices from "../../Invoice/TourServices";
import { currentTenant, currentUser } from "../../../Common/Credentials";
import moment from "moment";
import withRouter from "../../../withRouter";


const MRoomtype = (props) => {
  const [checked, setChecked] = useState(true)
  const nevigate = useNavigate();
  const [data, setData] = useState({
    id: 0,
    roomtype: "",
    remarks: "",
    createddate:new Date(),
    modifieddate:new Date(),
    tenantid:currentTenant,
    
  });
 

  useEffect(() => {
    console.log(props.location.state.id);
    if(props.location.state.id !== -1)
    {
      TourServices.getByIdMRoomType(props.location.state.id).then((e)=>{
        setData({
            id: e.data.id,
            roomtype: e.data.roomtype,
            remarks: e.data.remarks,
            createddate:e.data.createddate,
            modifieddate:e.data.modifieddate,
            tenantid:currentTenant,
        })
      })
    }
  },[])

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const changeHandler = (e) => {
    setData(prevValues => {
      return { ...prevValues, [e.target.name]: e.target.value }
    })
  }

  const AddHandler = (e) => {
    e.preventDefault();
    if(props.location.state.id === -1)
    {

      const sdata = {
      id: data.id,
      roomtype: data.roomtype,
      remarks: data.remarks,
      createddate:new Date(),
      modifieddate:new Date(),
      tenantid:currentTenant,
    }
    TourServices.addMRoomType(sdata).then((r) => {
      console.log(r.data);
    })
    nevigate("/MRoomtypeList");
    }
    else
    {
      const sdata = {
        id: data.id,
        roomtype: data.roomtype,
        remarks: data.remarks,
        createddate:data.createddate,
        modifieddate:new Date(),
        tenantid:currentTenant,
      }
        TourServices.updateMRoomType(sdata,props.location.state.id).then((r)=>{
          console.log(r);
        })
    }
 

  }


  return (
    <>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
          <span
                as="button"
                className=" text-secondary cursorPointer"
                
              >
                <Link to="/hotelroomtypelist" style={{color:"grey"}}>❮ Back &nbsp;&nbsp;</Link>
                
              </span>
            <li className="breadcrumb-item text-secondary">
              <Link to="/index">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/hotelroomtypelist">Room Type List</Link>
            </li>
            <li className="breadcrumb-item active">Master Room Type</li>
          </ol>
          <div className="">
            <form >
              <div className="card-body p-6">
                <div className="row my-1">
                  <fieldset className="col-md-4 col-sm-12">
                    <TextField
                      fullWidth
                      required="true"
                      type="text"
                      label="Room Type"
                      id="outlined-size-small"
                      size="small"
                      variant="outlined"
                      name="roomtype"
                      value={data.roomtype}
                      onChange={changeHandler}
                    />
                  </fieldset>
                  <fieldset className="col-md-8 col-sm-12">
                    <TextField
                      fullWidth
                      required="true"
                      type="text"
                      label="Remarks"
                      id="outlined-size-small"
                      size="small"
                      variant="outlined"
                      name="remarks"
                      value={data.remarks}
                      onChange={changeHandler}
                    />
                  </fieldset>
                </div>
 
                <div className="row my-1">
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="my-2">
                      <span>Created By : Jnanasoftware</span>
                    </div>
                 
                  </div>
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className=" my-2">
                      <span>Modified By : {currentUser}</span>
                    </div>
                  </div>
                </div>
                <div className="row my-1">
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="">
                      <span>Created Time : {moment(data.createddate).format("DD-MM-YYYY")}</span>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 d-flex ">
                    <div className="">
                      <span>Modified Time : {moment(data.modifieddate).format("DD-MM-yyyy")} </span>
                    </div>
                  </div>
                  <div className="btn d-flex justify-context-center">
                    <button className="btn buttonColour btn-sm  "  onClick={AddHandler}>ADD</button>
                  </div>
                </div>
              </div>
            </form>
            
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default withRouter(MRoomtype);
